import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Link } from "react-router-dom";
import { getLabTypes } from "../../store/catalogs/LabTypes/actions";

import bibliotecaNormas from "../../assets/images/menu/bibliotecaNormas_renewed.png";
import catalogo from "../../assets/images/menu/catálogos_updated.png";
import labCitec from "../../assets/images/menu/lab_Citec_updated.png";
import labMovil from "../../assets/images/menu/labMoviles_renewed.png";
import registroMuestras from "../../assets/images/menu/registro_muestras_updated.png";
import resultados from "../../assets/images/menu/resultados_updated.png";
import roi from "../../assets/images/menu/roi_renewed.png";
import { staticRoutes } from '../../routes/staticRoutes';

const Home = () => {

  const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabTypes(`?limit=100&page=0`))     
    }, [])

    // useEffect(() => {

    // }, [searchData])

    const role = (localStorage.getItem("authUser")) ?  JSON.parse(localStorage.getItem("authUser"))?.role : ''

    const { labtypes } = useSelector(state => ({
        labtypes: state.labType.labtypes,
    }), shallowEqual);

  const onClickCitec = () => {
    localStorage.setItem("lType", JSON.stringify('CITEC'));
    localStorage.setItem("lId", JSON.stringify(labtypes?.find(x => x.name === 'CITEC')?.id ?? ''));
  }

  const onClickMoviles = () => {
    localStorage.setItem("lType", JSON.stringify('Móvil'));
    localStorage.setItem("lId", JSON.stringify(labtypes?.find(x => x.name === 'Móvil')?.id ?? ''));
  }

  useEffect(() => {
    localStorage.setItem("CITEC", JSON.stringify(labtypes?.find(x => x.name === 'CITEC')?.id ?? ''));
    localStorage.setItem("Movil", JSON.stringify(labtypes?.find(x => x.name === 'Móvil')?.id ?? ''));
  }, [labtypes])

  return (
    <React.Fragment>
      <div className="page-content p-5" style={{ marginTop: 120 }}>
        {/* <Container className=""> */}
          <div className="container-fluid">

            {
                (role === 'Coordinador') ? 
                <div>
                  <div className="row mx-5">
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                      <Link to="/catalogs/menu" className="vb__utils__link">
                        <div className="card mx-3">
                          <div className="card-body">
                            <div className="d-flex justify-content-center align-items-center py-2 my-2">
                              <img src={catalogo} alt="" height="75" />
                            </div>
                            <div className="mt-4 d-flex justify-content-center align-items-center">
                              <h4 className="text-primary">Catálogos</h4>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                      <Link
                        to={{
                          pathname: `/labCitec`,
                          query: {
                            id: '19A3E635-D654-ED11-80D4-0050569D2DF6',
                            labType: 'CITEC'
                          }
                        }}
                        onClick={onClickCitec}
                        className="vb__utils__link">
                        <div className="card mx-3">
                          <div className="card-body">
                            <div className="d-flex justify-content-center align-items-center py-2 my-2">
                              <img src={labCitec} alt="" height="75" />
                            </div>
                            <div className="mt-4 d-flex justify-content-center align-items-center">
                              <h4 className="text-primary">Laboratorio CITEC</h4>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                      <Link 
                          to={{
                            pathname: `/labmoviles`,
                            query: {
                              id: '18A3E635-D654-ED11-80D4-0050569D2DF6',
                              labType: 'Móvil'
                            }
                          }}
                          onClick={onClickMoviles}
                          className="vb__utils__link">
                        <div className="card mx-3">
                          <div className="card-body mt-2">
                            <div className="d-flex justify-content-center align-items-center">
                              <img src={labMovil} alt="" height="90" />
                            </div>
                            <div className="mt-3 d-flex justify-content-center align-items-center">
                              <h4 className="text-primary">Laboratorio Móviles</h4>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                      <Link to="/normLibrary" className="vb__utils__link">
                        <div className="card mx-3">
                          <div className="card-body mt-2">
                            <div className="d-flex justify-content-center align-items-center">
                              <img src={bibliotecaNormas} alt="" height="90" />
                            </div>
                            <div className="mt-3 d-flex justify-content-center align-items-center">
                              <h4 className="text-primary">Biblioteca de Normas</h4>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    </div>


                    <div className="row mx-5 justify-content-between">

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to={staticRoutes.labRequestSamples.base} className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3">
                                <img src={registroMuestras} alt="" height="100" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Registro de Muestras</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to="/roi" className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3">
                                <img src={roi} alt="" height="95" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">ROI</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to="/results" className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3 ms-4">
                                <img src={resultados} alt="" height="90" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Resultados</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>



                    </div>
                </div> : 
                (role == 'Asesor Técnico') ? 
                  <div>
                      <div className="d-flex align-items-center justify-content-between mx-5">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                          <Link
                            to={{
                              pathname: `/labCitec`,
                              query: {
                                id: '19A3E635-D654-ED11-80D4-0050569D2DF6',
                                labType: 'CITEC'
                              }
                            }}
                            onClick={onClickCitec}
                            className="vb__utils__link">
                            <div className="card mx-3">
                              <div className="card-body">
                                <div className="d-flex justify-content-center align-items-center py-2 my-2">
                                  <img src={labCitec} alt="" height="75" />
                                </div>
                                <div className="mt-4 d-flex justify-content-center align-items-center">
                                  <h4 className="text-primary">Laboratorio CITEC</h4>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                          <Link 
                              to={{
                                pathname: `/labmoviles`,
                                query: {
                                  id: '18A3E635-D654-ED11-80D4-0050569D2DF6',
                                  labType: 'Móvil'
                                }
                              }}
                              onClick={onClickMoviles}
                              className="vb__utils__link">
                            <div className="card mx-3">
                              <div className="card-body mt-2">
                                <div className="d-flex justify-content-center align-items-center">
                                  <img src={labMovil} alt="" height="90" />
                                </div>
                                <div className="mt-3 d-flex justify-content-center align-items-center">
                                  <h4 className="text-primary">Laboratorio Móviles</h4>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                          <Link to="/normLibrary" className="vb__utils__link">
                            <div className="card mx-3">
                              <div className="card-body mt-2">
                                <div className="d-flex justify-content-center align-items-center">
                                  <img src={bibliotecaNormas} alt="" height="90" />
                                </div>
                                <div className="mt-3 d-flex justify-content-center align-items-center">
                                  <h4 className="text-primary">Biblioteca de Normas</h4>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>

                        </div>
                  </div>  : 
                  (role == 'Laboratorista') ?
                  <div>
                    <div className="d-flex align-items-center justify-content-between mx-5">

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link
                          to={{
                            pathname: `/labCitec`,
                            query: {
                              id: '19A3E635-D654-ED11-80D4-0050569D2DF6',
                              labType: 'CITEC'
                            }
                          }}
                          onClick={onClickCitec}
                          className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center py-2 my-2">
                                <img src={labCitec} alt="" height="75" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Laboratorio CITEC</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link 
                            to={{
                              pathname: `/labmoviles`,
                              query: {
                                id: '18A3E635-D654-ED11-80D4-0050569D2DF6',
                                labType: 'Móvil'
                              }
                            }}
                            onClick={onClickMoviles}
                            className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body mt-2">
                              <div className="d-flex justify-content-center align-items-center">
                                <img src={labMovil} alt="" height="90" />
                              </div>
                              <div className="mt-3 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Laboratorio Móviles</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to="/normLibrary" className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body mt-2">
                              <div className="d-flex justify-content-center align-items-center">
                                <img src={bibliotecaNormas} alt="" height="90" />
                              </div>
                              <div className="mt-3 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Biblioteca de Normas</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                    </div>

                    <div className="d-flex align-items-center justify-content-between mx-5">

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to={staticRoutes.labRequestSamples.base} className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3">
                                <img src={registroMuestras} alt="" height="100" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Registro de Muestras</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to="/roi" className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3">
                                <img src={roi} alt="" height="95" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">ROI</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                        <Link to="/results" className="vb__utils__link">
                          <div className="card mx-3">
                            <div className="card-body">
                              <div className="d-flex justify-content-center align-items-center mt-3 ms-4">
                                <img src={resultados} alt="" height="90" />
                              </div>
                              <div className="mt-4 d-flex justify-content-center align-items-center">
                                <h4 className="text-primary">Resultados</h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>

                    </div>

                </div> : null
                
            }

            

          </div>
        {/* </Container> */}
      </div>
    </React.Fragment>
  )
}

export default Home